import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { PatientjourneyService } from '../../_service/patientjourney.service';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { HotTableRegisterer } from '@handsontable/angular';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
declare var $: any;
@Component({
  selector: 'app-patient-journey-tracker',
  templateUrl: './patient-journey-tracker.component.html',
  styleUrls: ['./patient-journey-tracker.component.css']
})
export class PatientJourneyTrackerComponent implements OnInit {
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  IpdData:any=[];private hotRegisterer = new HotTableRegisterer();settings = {colHeaders: true };hideColumn:any;loaded:boolean=false;perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;id = 'hotInstance';
  pageSizeOptions = [10,25,50,100];pageIndex:number=0;
  search:string;bd:string;start_date:string='';end_date:string='';admissionstart_date:string='';admissionend_date:string='';doctor:string;
  paymentOpt=[];ActionOpt=[];myrole:string;adminRole:boolean=true;adminInsuranceRole:boolean=true;
  bds=[];bds_copy=[];doctors_copy=[];hospitals_copy=[];treatments_copy=[];doctors=[];hospitals=[];alltreatments=[];treatments=[];leadStatus=[];circles=[];columnDrp:number[]=[];submitted = false;
  reimbursement_cancelled_cheque=[]
  constructor(private leadapi:LeadsService, private sharedapi:SharedService,private patientjourneyapi:PatientjourneyService) { }

  ngOnInit(): void {
    this.sharedapi.getRole()
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
  }
  ngAfterViewInit() {
    this.loadData(0,25);
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadData(event.pageIndex,event.pageSize);
  }

  async loadData(pageIndex,perpage)
  {
      this.IpdData = [];
      this.paginator.pageIndex = pageIndex;
      this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;
      let qString = 'search='+this.search+'&date_range='+this.start_date+'-'+this.end_date;
      this.loading = true;this.loaded = false;
      this.patientjourneyapi.getDischargedPatienttracker(pageIndex,perpage,qString).subscribe((data:any) => {
        this.length = parseInt(data.totaldata);
        this.loading = false;
        this.loaded = true;
        if(data.status)
        {
            this.IpdData = data.data;

        }else{
            this.IpdData = [];
            this.sharedapi.presentToast(data.msg);
        }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          this.loadData(0,this.perpage);
      }
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.loadData(0,this.perpage);
  }

}
